import { Routes, Route, Navigate } from "react-router-dom";
import { Layout, App as AntApp } from "antd";
import ResetPassword from "./pages/ResetPassword";
import UserHome from "./pages/UserHome";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Hub from "./pages/Hub";
import OrderDashboard from "./pages/OrderDashboard/OrderDashboard.js";
import OrderDetailPage from "./pages/OrderDashboard/OrderDetailPage.js";
import StoreEditorPage from "./pages/Hub/createStore.js";
import Subscription from "./pages/Subscription";
import HubSettings from "./pages/HubSettings";
import KYCPending, { KYCUpload, KYCRequested, KYCVerified, KYCRejected } from "./pages/KYC";
import MediaGallery from "./pages/Gallery/MediaGallery";
import Notebook from "./pages/Notebook";
import PageContainer from "./components/PageContainer/PageContainer";
import { ProductBuilder } from "./pages/ProductBuilder";
import NotFound from "./pages/NotFound";
import Landing from "./pages/Landing";
import PrivateRoute from "./context/PrivateRoute";
import SubscriptionGate from "./components/SubscriptionGate";
import { ThemeProvider } from "./theme/ThemeProvider";
import { PublicShell } from "./components/shells";
import { useAuth } from "./context/AuthContext";
import ApiErrorNotifier from "./components/ApiErrorNotifier";

/** Public `/` → `/home`; authenticated `/` → `/hub`. */
function RootRedirect() {
  const { token } = useAuth();
  const isE2eBypass = process.env.REACT_APP_E2E_BYPASS_AUTH === "1";
  if (token || isE2eBypass) {
    return <Navigate to="/hub" replace />;
  }
  return <Navigate to="/home" replace />;
}

const App = () => {
  return (
    <ThemeProvider>
      <AntApp>
        <ApiErrorNotifier />
        <Layout style={{ minHeight: "100vh" }}>
          <Layout.Content>
            <Routes>
              <Route path="/" element={<RootRedirect />} />
              <Route path="/home" element={<Landing />} />
              <Route path="/resetpassword" element={<PublicShell><ResetPassword /></PublicShell>} />
              <Route path="/register" element={<PublicShell><Register /></PublicShell>} />
              <Route path="/login" element={<PublicShell><Login /></PublicShell>} />

              {/* Protected app layout — pathless parent so `/` can stay public */}
              <Route
                element={
                  <PrivateRoute>
                    <SubscriptionGate>
                      <UserHome />
                    </SubscriptionGate>
                  </PrivateRoute>
                }
              >
                <Route path="hub" element={<Hub />} />
                <Route path="dashboard" element={<OrderDashboard />} />
                <Route path="dashboards/orderdetailpage" element={<OrderDetailPage />} />
                <Route path="biz/create" element={<StoreEditorPage />} />
                <Route path="biz/edit/:id" element={<StoreEditorPage />} />
                <Route path="gallery" element={<MediaGallery />} />
                <Route path="notebook" element={<PageContainer><Notebook /></PageContainer>} />
                <Route path="hubSettings" element={<HubSettings />} />
                <Route path="hubSettings/kyc">
                  <Route index element={<KYCPending />} />
                  <Route path="upload" element={<KYCUpload />} />
                  <Route path="requested" element={<KYCRequested />} />
                  <Route path="verified" element={<KYCVerified />} />
                  <Route path="rejected" element={<KYCRejected />} />
                </Route>
                <Route path="subscription" element={<Subscription />} />
                <Route path="product-builder" element={<ProductBuilder />} />
                <Route path="log" element={<div>Logs</div>} />
                <Route path="*" element={<NotFound />} />
              </Route>
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout.Content>
        </Layout>
      </AntApp>
    </ThemeProvider>
  );
};

export default App;
